module.exports = __webpack_public_path__ + "img/recommend.24355689.png";